import React from 'react';
import { FolderKanban, MessageSquare, TrendingUp, Users } from 'lucide-react';
import { motion } from 'framer-motion';

export default function Dashboard() {
  const stats = [
    { title: 'Aktif Projeler', value: '4', icon: <FolderKanban size={24} />, color: 'text-blue-500', bg: 'bg-blue-500/10' },
    { title: 'Yeni Mesajlar', value: '12', icon: <MessageSquare size={24} />, color: 'text-amber-500', bg: 'bg-amber-500/10' },
    { title: 'Aylık Ziyaretçi', value: '8.4K', icon: <Users size={24} />, color: 'text-emerald-500', bg: 'bg-emerald-500/10' },
    { title: 'Dönüşüm Oranı', value: '%14.2', icon: <TrendingUp size={24} />, color: 'text-purple-500', bg: 'bg-purple-500/10' }
  ];

  return (
    <div className="space-y-8">
      {/* Welcome Card */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-gradient-to-r from-red-600 to-red-800 rounded-3xl p-8 text-white shadow-2xl shadow-red-600/20 relative overflow-hidden text-left"
      >
        <div className="absolute right-0 bottom-0 opacity-10 translate-x-1/4 translate-y-1/4 pointer-events-none">
          <i className="ri-building-line text-[200px]"></i>
        </div>
        <h2 className="text-3xl font-black mb-2" style={{ fontFamily: 'Raleway, sans-serif' }}>Hoş Geldiniz, Yönetici! 👋</h2>
        <p className="text-red-100 max-w-xl text-sm leading-relaxed">
          KARE YAPI İNŞAAT operasyon merkezindesiniz. Sol menüyü kullanarak projelerinizi yönetebilir, müşteri taleplerini anında görüntüleyebilirsiniz.
        </p>
      </motion.div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.1 * idx }}
            className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 text-left hover:-translate-y-1 transition-transform cursor-default"
          >
            <div className="flex justify-between items-start mb-4">
              <div className={`p-4 rounded-xl ${stat.bg} ${stat.color}`}>
                {stat.icon}
              </div>
            </div>
            <div className="text-3xl font-black text-white mb-1" style={{ fontFamily: 'Raleway, sans-serif' }}>{stat.value}</div>
            <div className="text-zinc-500 text-sm font-medium">{stat.title}</div>
          </motion.div>
        ))}
      </div>

    </div>
  );
}
